const headRowsExpiredServices = {
  date: 'Overdue Services Dates',
  equipmentEquipmentParamName: 'Equipment',
  inspection: 'Service Types',
  questions: 'Checklist',
  placeName: 'Local',
};

export default headRowsExpiredServices;
